import { recordPath, recordRoute } from '@/shared/registry'

/** Where the achievement pages live. */
export const achievementsPath = '/credentials/achievements'
export const createAchievementPath = `${achievementsPath}/new`
export const achievementRoute = recordRoute('credentials', 'achievements')
export const editAchievementRoute = `${achievementRoute}/edit`

/** An achievement's details page. */
export function achievementPath(id: string): string {
  return recordPath('credentials', 'achievements', id)
}

/** The base of Achievement Details' slots (`detailsSlots`). */
export const achievementDetailsSlot = 'credentials.achievement-details'

/** The permissions the achievement screens show or hide their actions by. */
export const readAchievementsPermission = 'credentials.achievements.read'
export const writeAchievementsPermission = 'credentials.achievements.write'
export const deleteAchievementsPermission = 'credentials.achievements.delete'

/** Sharing an achievement with every organization that takes part. */
export const writeGlobalAchievementsPermission = 'credentials.achievements.global.write'

/** The API's achievement endpoints. */
export const achievementsApi = '/credentials/v1/achievements'

export function achievementApi(id: string): string {
  return `${achievementsApi}/${encodeURIComponent(id)}`
}
